import React, { Fragment } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    Paper,
    FormLabel,
    FormControl,
    ListItemAvatar,
    colors,
    Checkbox,
    Avatar,
    Icon,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from '@material-ui/core';

import { BsFillPersonFill } from "react-icons/bs";

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.blue[400],
        '&$checked': {
            color: colors.blue[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    userlist: {
        width: '100%',
        maxHeight: 340,
        overflow: 'auto'
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const Group = ({ item, open, closeEdition, updateValues, dependencies, checked, handleToggle }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Equipe
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                name: Yup.string().max(255).required('Nome é obrigatório'),
                                description: Yup.string().max(255).required('Descrição é o obrigatória'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            values.mailto = checked;
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            helperText={touched.name && errors.name}
                                            label="Nome"
                                            margin="normal"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.description && errors.description)}
                                            fullWidth
                                            helperText={touched.description && errors.description}
                                            label="Descrição"
                                            rows={4}
                                            multiline
                                            margin="none"
                                            name="description"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.description}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <Paper variant="outlined" rounded >
                                            <FormControl component="fieldset" fullWidth  >
                                                <FormLabel style={{ padding: 10 }} >
                                                    <b>Usuários Participantes</b>
                                                </FormLabel>

                                                <Divider></Divider>

                                                <List dense component={PerfectScrollbar} className={classes.userlist}>
                                                    {dependencies.users.map((user, index) => {
                                                        return (
                                                            <ListItem key={index} autoFocus={true}>
                                                                <ListItemAvatar>
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={BsFillPersonFill} style={{ color: colors.blue[400] }} ></Icon>}
                                                                    </Avatar>
                                                                </ListItemAvatar>
                                                                <ListItemText id={user._id} primary={user.firstname + ` ` + user.lastname}
                                                                    secondary={`Email: ` + user.email} />
                                                                <ListItemSecondaryAction>
                                                                    <ColorCheckbox
                                                                        edge="end"
                                                                        onChange={handleToggle(user._id, 'user')}
                                                                        checked={checked.indexOf(user._id) != -1}
                                                                        inputProps={{ 'aria-labelledby': user._id }}
                                                                    />
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        );
                                                    })}

                                                </List>
                                            </FormControl>
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Group;
